import { render, staticRenderFns } from "./NewPassword.vue?vue&type=template&id=03656370&scoped=true"
import script from "./NewPassword.vue?vue&type=script&lang=js"
export * from "./NewPassword.vue?vue&type=script&lang=js"
import style0 from "./NewPassword.vue?vue&type=style&index=0&id=03656370&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03656370",
  null
  
)

export default component.exports